module.exports = __webpack_public_path__ + "assets/political_election.d800a05d.svg";